export const NAME = 'deposits';
